import { render, staticRenderFns } from "./sportClubBoardTypeListing.vue?vue&type=template&id=6b11a5ef&"
import script from "./sportClubBoardTypeListing.vue?vue&type=script&lang=js&"
export * from "./sportClubBoardTypeListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports